// ==========================================
// 1. 基础配置
// ==========================================
const SHOP_DOMAIN = 'ku9z1r-p7.myshopify.com'; 
const STOREFRONT_ACCESS_TOKEN = 'c0bc5d8b6adb1c488eaf2a48f2cc47fd';
const API_VERSION = '2024-10'; 


// ==========================================
// 2. 全局折扣状态管理器 (支持多折扣叠加)
// ==========================================
window.DiscountManager = {
  // 获取所有生效的折扣码 (返回数组)
  getCodes: function() {
    const codesStr = sessionStorage.getItem('active_discount_codes');
    return codesStr ? JSON.parse(codesStr) : [];
  },
  
  // 新增一个折扣码到池子里 (自动去重并转大写)
  addCode: function(code) {
    if (!code || code.trim() === "") return;
    const codes = this.getCodes();
    const cleanCode = code.trim().toUpperCase();
    if (!codes.includes(cleanCode)) {
      codes.push(cleanCode);
      sessionStorage.setItem('active_discount_codes', JSON.stringify(codes));
    }
  },

  // 移除某个特定的折扣码
  removeCode: function(code) {
    if (!code) return;
    let codes = this.getCodes();
    codes = codes.filter(c => c !== code.trim().toUpperCase());
    sessionStorage.setItem('active_discount_codes', JSON.stringify(codes));
  },

  // 清空所有折扣码
  clearAll: function() {
    sessionStorage.removeItem('active_discount_codes');
  },

  // 新增折扣码并触发全站同步
  addAndSync: async function(code) {
    this.addCode(code);
    try {
      const res = await fetch('/cart.js');
      const cartData = await res.json();
      console.log(`[DiscountManager] 新增折扣 ${code}，当前所有折扣:`, this.getCodes());
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true, 
        detail: { cart: cartData }
      }));
    } catch (err) {
      console.error("[DiscountManager] 同步失败:", err);
    }
  }
};

// ==========================================
// 3. 核心 API 请求方法
// ==========================================
async function shopifyStorefrontRequest(query, variables = {}) {
  const url = `https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({ query, variables }),
  });

  if (!response.ok) throw new Error(`HTTP 错误: ${response.status}`);
  const result = await response.json();
  if (result.errors) throw new Error(result.errors[0].message);
  return result.data;
}

// 批量验证折扣码 (支持数组)
async function applyDiscountCodes(cartId, discountCodesArray) {
  const mutation = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          discountCodes { code applicable }
          estimatedCost {
            subtotalAmount { amount currencyCode }
            totalAmount { amount currencyCode }
          }
        }
        userErrors { field message }
      }
    }
  `;

  try {
    const data = await shopifyStorefrontRequest(mutation, { 
      cartId, 
      discountCodes: discountCodesArray 
    });
    
    const result = data.cartDiscountCodesUpdate;

    if (result.userErrors && result.userErrors.length > 0) {
      return { success: false, message: result.userErrors[0].message };
    }

    const cart = result.cart;
    
    return {
      success: true,
      appliedCodes: cart.discountCodes.filter(d => d.applicable).map(d => d.code),
      rejectedCodes: cart.discountCodes.filter(d => !d.applicable).map(d => d.code),
      subtotal: cart.estimatedCost.subtotalAmount.amount,
      total: cart.estimatedCost.totalAmount.amount,
      currency: cart.estimatedCost.totalAmount.currencyCode
    };
  } catch (error) {
    console.error("请求失败:", error);
    return { success: false, message: "网络请求失败，请稍后再试" };
  }
}

// ==========================================
// 4. 辅助功能函数 (DOM 与 UI)
// ==========================================
async function getCurrentCartId() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return `gid://shopify/Cart/${cart.token}`;
  } catch (err) {
    console.error("获取购物车 ID 失败", err);
    return null;
  }
}

// 挂载折扣到传统 Form 表单 (支持逗号分隔的多码)
function appendDiscountToCheckoutForm(validCodesString) {
  const cartForm = document.querySelector('form[action="/cart"]');
  if (cartForm) {
    let hiddenInput = cartForm.querySelector('input[name="discount"]');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'discount';
      cartForm.appendChild(hiddenInput);
    }
    hiddenInput.value = validCodesString;
  }
}

// 暴力防抖渲染器
function forceRenderDiscountUI(result) {
  if (!result || !result.success) return;

  const savedAmount = (parseFloat(result.subtotal) - parseFloat(result.total)).toFixed(2);
  let renderCount = 0;
  
  const renderInterval = setInterval(() => {
    const msgDiv = document.getElementById('discount-message-new'); 
    const totalDisplay = document.getElementById('cart-total-display-new');

    if (msgDiv && totalDisplay) {
      // msgDiv.innerHTML = `✅ 已應用: ${result.appliedCodes.join(', ')} <br> <div class="discount_codes">為您節省了 ${savedAmount} ${result.currency}</div>`;
      // msgDiv.style.color = "green";
      
      // totalDisplay.innerHTML = `
      //   <div class="discount_price-new">${result.subtotal} ${result.currency}</div>
      //   <div class="price-new">${result.total} ${result.currency}</div>
      // `;
    }

    renderCount++;
    if (renderCount >= 6) clearInterval(renderInterval);
  }, 300);
}

// ==========================================
// 5. 监听主题原生刷新事件 (改数量、清空购物车)
// ==========================================
document.documentElement.addEventListener("cart:refresh", (event) => {
  const cartData = event.detail.cart;
  if (!cartData) return;

  // 购物车被清空了，彻底擦除折扣记忆
  if (cartData.item_count === 0) {
    console.log("购物车已空，清除折扣状态...");
    window.DiscountManager.clearAll();
    const cartForm = document.querySelector('form[action="/cart"]');
    if (cartForm) {
       const hiddenInput = cartForm.querySelector('input[name="discount"]');
       if (hiddenInput) hiddenInput.remove();
    }
    fetch('/discount/CLEAR').catch(() => {});
    return;
  }

  const currentCodes = window.DiscountManager.getCodes();

  // 购物车商品数量改变，自动基于新数量重算折扣
  if (currentCodes.length > 0 && cartData.token) {
    console.log(`数量改变，重新计算折扣: ${currentCodes.join(', ')}`); 
    
    // 取消了 setTimeout 的包裹，加快响应速度
    const myCartId = `gid://shopify/Cart/${cartData.token}`;
    
    applyDiscountCodes(myCartId, currentCodes).then(result => {
      const msgDiv = document.getElementById('discount-message-new');
      const totalDisplay = document.getElementById('cart-total-display-new');
      if (!msgDiv || !totalDisplay) return;

      if (result.success) {
        // 1. 剔除掉因为数量/商品改变而导致不再满足条件的失效折扣码
        if (result.rejectedCodes && result.rejectedCodes.length > 0) {
          result.rejectedCodes.forEach(code => window.DiscountManager.removeCode(code));
          console.log("已自动移除失效的折扣码:", result.rejectedCodes);
        }

        // 2. 挂载依然有效的折扣码 (用逗号拼接)
        if (result.appliedCodes && result.appliedCodes.length > 0) {
          appendDiscountToCheckoutForm(result.appliedCodes.join(','));
        } else {
          const cartForm = document.querySelector('form[action="/cart"]');
          if (cartForm) {
            const hiddenInput = cartForm.querySelector('input[name="discount"]');
            if (hiddenInput) hiddenInput.remove();
          }
        }

        // 3. 护航 UI 渲染
        forceRenderDiscountUI(result);

      } else {
        // GraphQL 彻底报错失败的情况
        msgDiv.style.color = "#E0004D";
        window.DiscountManager.clearAll(); 
      }
    });
  }
});

// ==========================================
// 6. 事件代理：处理用户主动点击“应用折扣”按钮
// ==========================================
document.body.addEventListener('click', async (e) => {
  const applyBtn = e.target.closest('#apply-discount-btn-new');
  if (!applyBtn) return;

  e.preventDefault();

  const codeInput = document.getElementById('cart-discount-input-new');
  let msgDiv = document.getElementById('discount-message-new');
  let totalDisplay = document.getElementById('cart-total-display-new');

  if (!codeInput || !msgDiv || !totalDisplay) return;

  const codeValue = codeInput.value.trim().toUpperCase();

  if (!codeValue) {
    msgDiv.innerText = "Please enter the promo code.";
    msgDiv.style.color = "#E0004D";
    return;
  }

  applyBtn.disabled = true;
  applyBtn.classList.add('is-loading'); 
  msgDiv.innerText = ""; 

  try {
    const myCartId = await getCurrentCartId();
    if (!myCartId) throw new Error("获取购物车 ID 失败");

    // 获取历史生效的码，并和这次新输入的码合并去重测试
    const existingCodes = window.DiscountManager.getCodes();
    const codesToTest = [...new Set([...existingCodes, codeValue])]; 

    const result = await applyDiscountCodes(myCartId, codesToTest);
    console.log('API Result:', result);

    // 验证返回结果，确保新输入的 codeValue 验证成功了
    if (result.success && result.appliedCodes && result.appliedCodes.includes(codeValue)) {
      
      // 1. 将新输入的码加入全局管理器 (内部自动去重追加)
      window.DiscountManager.addCode(codeValue);
      
      // 2. 核心修正：挂载和种 Cookie 时，必须使用逗号拼接【所有生效的码】，防止覆盖
      const allActiveCodes = result.appliedCodes.join(',');
      appendDiscountToCheckoutForm(allActiveCodes);

      // 3. 物理外挂：静默种下后端 Cookie，彻底防止刷新掉效果
      await fetch(`/discount/${allActiveCodes}`).catch(() => {});

      // 4. 主动触发全局刷新事件
      const resCart = await fetch('/cart.js');
      const cartData = await resCart.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true, 
        detail: { cart: cartData }
      }));

      // 5. 调用强制 UI 渲染器
      forceRenderDiscountUI(result);

    } else {
      // 不满足条件或新输入的码掉进了 rejectedCodes
      msgDiv.innerText = `❌ The promo code is invalid or does not meet the usage conditions.`;
      msgDiv.style.color = "#E0004D";
    }
  } catch (error) {
    console.error("【应用折扣报错】:", error);
    msgDiv.innerText = "Network error, please try again later.";
    msgDiv.style.color = "#E0004D";
  } finally {
    applyBtn.disabled = false;
    applyBtn.classList.remove('is-loading');
  }
});